import {isIOS, isMacOs, isIE} from "react-device-detect";

export default (sourceArr)=>{
    if(isIOS || isMacOs || isIE ) {
        return  sourceArr[1]
    }
    return sourceArr[0]
}
